const LOGIN_CONFIRM_STORAGE_KEY = '_loginConfirm_Sucessful_Confirmed'

/**
 * Stores the state that user has confirmed the password successfully
 */
const storeSuccessfulConfirmation = function (forRef, forAccessToken) {
  sessionStorage.setItem(LOGIN_CONFIRM_STORAGE_KEY + forRef + forAccessToken.substring(0, 8), 'confirmed')
}

/**
 * Stores the state that user has confirmed the password successfully
 */
const resetSuccessfulConfirmation = function (forRef, forAccessToken) {
  sessionStorage.removeItem(LOGIN_CONFIRM_STORAGE_KEY + forRef + forAccessToken.substring(0, 8))
}

/**
 * Checks if the user has already confirmed the login
 */
const loginAlreadyConfirmed = function (forRef, forAccessToken) {
  return (sessionStorage.getItem(LOGIN_CONFIRM_STORAGE_KEY + forRef + forAccessToken.substring(0, 8)) === 'confirmed')
}

export default function doLoginConfirm (ref) {
  return {
    data () {
      return {
        refLoginConfirmComponent: ref
      }
    },
    methods: {
      resetLoginConfirm () {
        const at = this.$store.getters?.accessToken ? this.$store.getters.accessToken : ''
        resetSuccessfulConfirmation(this.refLoginConfirmComponent, at)
      },
      doLoginConfirm () {
        const at = this.$store.getters?.accessToken ? this.$store.getters.accessToken : ''
        const _this = this
        return new Promise(function (resolve, reject) {
          // if already confirmed, resolve directly
          if (loginAlreadyConfirmed(_this.refLoginConfirmComponent, at)) {
            resolve()
          } else {
            // check for reference to login confirm component
            if (_this.$refs[_this.refLoginConfirmComponent] && typeof _this.$refs[_this.refLoginConfirmComponent].letUserConfirmPassword === 'function') {
              _this.$refs[_this.refLoginConfirmComponent].letUserConfirmPassword().then(() => {
                storeSuccessfulConfirmation(_this.refLoginConfirmComponent, at)
                resolve()
              }, () => {
                reject(new Error('login confirmation failed'))
              })
            } else {
              // missing component / reference
              console.error('Missing reference to / or component to LoginConfirm component')
            }
          }
        })
      }
    }
  }
}
